<template>
    <button type="button" class="btn btn-sm btn-outline-dark mb-3" @click="openCreateModal()">
        <i class="fas fa-plus"></i> Nouveau garage
    </button>

    <DataTableBackend v-if="dataReady" :url="'/api/' + table" :columns="columns" :table="table" :perPage="6">
        <template #action_btns=slotProps>
            <button class="btn btn-sm btn-light m-1" @click="openShowModal(slotProps.data)">
                <i class="fa-solid fa-ellipsis"></i>
            </button>
        </template>
    </DataTableBackend>
    <div v-else class="d-flex justify-content-center my-3">
        <div class="spinner-border text-primary" role="status">

        </div>
    </div>
</template>

<script>
import { defineComponent, defineAsyncComponent } from 'vue';
const CreateGarage = defineAsyncComponent(() => import('./CreateGarage.vue'));
const ShowGarage = defineAsyncComponent(() => import('./ShowGarage.vue'));

export default defineComponent({
    name: 'IndexGarage',
    data() {
        return {
            table: 'garages',
            isLoading: false,
            dataReady: false,
            baseUrl: this.$store.state.api_yams_interventions,
            columns: [
                {
                    key: 'nom',
                    label: 'Nom',
                    exportable: true
                },
                {
                    key: 'adresse',
                    label: 'Adresse',
                    exportable: true
                },
                {
                    key: 'ville',
                    label: 'Ville',
                    exportable: true
                },
            ]
        }
    },

    mounted() {
        this.checkApiAvailability();
    },

    methods: {
        checkApiAvailability() {
            this.isLoading = true;
            this.axios.get('/api/' + this.table + '?limit=1')
                .then(() => {
                    this.dataReady = true;
                    this.isLoading = false;
                })
                .catch((error) => {
                    console.error("Erreur lors du chargement des garages:", error);
                    // Réessayer après un court délai
                    setTimeout(() => this.checkApiAvailability(), 2000);
                });
        },

        openCreateModal() {
            this.$dialog.open(CreateGarage, {
                props: {
                    header: "Nouveau garage",
                    style: {
                        width: '50vw'
                    },
                    modal: true
                }
            });
        },

        openShowModal(objData) {
            this.$dialog.open(ShowGarage, {
                props: {
                    header: "Garage N°" + objData.id,
                    style: {
                        width: '50vw'
                    },
                    modal: true
                },
                data: objData
            });
        }
    }
})
</script>
